import { Injectable } from '@angular/core';
import {Headers} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {environment} from '../../../../../environments/environment';
import {Field} from '../../interfaces/Field';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {ErrorService} from '../../../utilities/services/error/error.service';

@Injectable()
export class FieldService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private fieldGroupsUrl = 'fieldgroup';
  private fieldUrl = 'field';

  constructor(private http: AuthHttp, public errorDialogService: ErrorService) {
  }

  public create(parentId: number, newItem: Field) {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${parentId}/${this.fieldUrl}`;
    newItem = {...newItem, id: parentId, datasource: newItem.datasource, calculation: newItem.calculation};
    return this.http
      .post(url, JSON.stringify(newItem), {headers: this.headers})
      .map(res => res.json())
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public get(parentId: number, id: number) {
      const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${parentId}/${this.fieldUrl}/${id}`;
      return this.http
          .get(url, {headers: this.headers})
          .map(res => res.json())
          .toPromise()
        .catch(error => this.handleError(error));
  }

  public update(updatedItem) {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${updatedItem.field_group_id}/${this.fieldUrl}/${updatedItem.id}`;
    return this.http
      .put(url, JSON.stringify(updatedItem), {headers: this.headers})
      .map(res => res.json())
      .toPromise()
      .catch(error => this.handleError(error));
  }

  /**
   *
   * @param updatedItems
   * @param parentId
   * @returns {Promise<null>}
   */
  public updateMany(updatedItems, parentId) {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${parentId}/${this.fieldUrl}`;
    return this.http
      .put(url, updatedItems, {headers: this.headers})
      .toPromise()
      .then(response => console.log(response))
      .catch(error => this.handleError(error));
  }

  public delete(parentId: number, id: number): Promise<void> {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${parentId}/${this.fieldUrl}/${id}`;
    return this.http
      .delete(url, {headers: this.headers})
      .toPromise()
      .then(() => null)
      .catch(error => this.handleError(error));
  }

  private handleError(error: Response) {
    console.log('handleError', error);
    this.errorDialogService.openDialog(error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/field/field.service.ts